<template lang="html">
<div class="d-flex flex-column">
    <div v-if="title" class="d-flex flex-row mb-0 p-3 pb-3">
        <div class="text-primary cta-3">{{ filtered_establishment_set.length }} {{ title }}</div>
        <div v-if="loading" class="pad">
            <span class="icon">
                <i class="fas fa-spinner fa-spin"></i>
            </span>
        </div>
    </div>
    <div class="list"
         style="box-shadow: none !important; flex-grow: 1; max-height: 100%;">
        <div class="row g-0 sh-6 mb-3"
             v-for="item in filtered_establishment_set"
             :class="{'selected': selectable && item.uid == $store.state.selected_establishment_uid, 'selectable': selectable}"
             @click="select(item)">
            <div class="card-body d-flex flex-row h-100 align-items-center" style="gap: 15px;">
                <EstablishmentLogo :establishment="item" rounded></EstablishmentLogo>
                <div class="d-flex flex-column">
                    <div class="name" style="color: var(--primary);">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import EstablishmentLogo from '@/components/EstablishmentLogo.vue';
import ESTABLISHMENT_SET from '@/gql/queries/establishmentSet.graphql';
import { gqlQuery } from '@/gqlClient.js';

export default {
  name: 'EstablishmentList',
  components: { EstablishmentLogo },
  props: {
    title: {
      type: [String, Boolean],
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    autoload: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default() {
        return {
          negative: false,
          positive: false,
          search_string: ''
        };
      }
    }
  },
  data() {
    return {
      loading: true,
      establishments: []
    };
  },
  computed: {
    filtered_establishment_set() {
      if (this.filters.search_string !== '') {
        const q = this.filters.search_string.toLowerCase();
        return this.establishments.filter(e =>
          e.name && e.name.toLowerCase().includes(q)
        );
      } else {
        return this.establishments;
      }
    },
    activeConsultantUid() {
      if (this.filters && this.filters.consultant && this.filters.consultant.uid) {
        return this.filters.consultant.uid;
      }
      return this.$store.state.selected_consultant_uid || null;
    }
  },
  methods: {
    select(item) {
      if (this.selectable) {
        this.$router.push({ name: 'establishment', params: { uid: item.uid } });
      }
    }
  },
  mounted() {
    const fetchAndInit = async () => {
      const res = await gqlQuery(ESTABLISHMENT_SET, { active: true });
      this.establishments = res.body.data.establishment_set || [];
      this.loading = false;
      if (!this.$route.params.uid && this.establishments.length > 0) {
        this.$router.push({ name: 'establishment', params: { uid: this.establishments[0].uid } });
      }
    };
    if (this.autoload) fetchAndInit();
    if (this.$route.params.uid) {
      this.$store.commit('select_establishment', this.$route.params.uid);
    }
  },
  beforeDestroy() {
    this.$store.commit('select_establishment', null);
  },
  watch: {
    activeConsultantUid(newV, oldV) {
      if (newV === oldV) return;
      this.loading = true;
      const vars = newV ? { consultant_uid: newV, active: true } : { active: true };
      gqlQuery(ESTABLISHMENT_SET, vars).then(res => {
        this.establishments = res.body.data.establishment_set || [];
        this.loading = false;
      });
    },
    '$route.params'(newV, oldV) {
      if (newV.uid !== oldV.uid) {
        this.$store.commit('select_establishment', newV.uid);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list{
    overflow-y: scroll;
}
.selectable:hover {
    cursor: pointer;
}
.selected {
    /* background-color: #eee; */
    font-weight: bold;
}
.card-content{
    padding:10px;
}
.card-header-title{
    padding:10px 0 12px 10px;
    height:50px;
}
.unmarged{
    margin-top:-8px;
    margin-left:-16px;
}
.card-header{
    padding:0;
    display:flex;
}
.card{
    border-radius:0.25rem;
}
.cursor{
    cursor: pointer;
}
.pad {
    padding: 0 32px;
}
</style>
